import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';
import { CalculatorMessages } from '../Calculator.messages';
import styles from '../Calculator.module.css';
import { SpecialServiceModal } from './SpecialServiceModal';

export type SpecialServiceOptInProps = {
  strings: CalculatorMessages;
};

export const SpecialServiceOptIn = ({ strings }: SpecialServiceOptInProps) => {
  const { openModal } = useModal();

  const handleOpenModal = () => {
    openModal(<SpecialServiceModal serviceModalStrings={strings} />, {
      header: strings.additionalContractSubheader,
      modalClassName: styles.modalSpecialContainer,
      modalBodyClassName: styles.modalSpecialBody,
    });
  };

  return (
    <div>
      <div className={styles.headerContainer}>
        <Typography variant="body1" Component="p">
          {strings.additionalContractHeader}
        </Typography>

        <Typography
          className={styles.clickableSubheader}
          variant="body1"
          Component="p"
          onClick={handleOpenModal}
        >
          {strings.additionalContractSubheader}
        </Typography>
      </div>
    </div>
  );
};
